import React, { Component } from "react";
import {
  profile,
  total,
  toFixed,
  format_date,
  GET,
  loading,
  Status,
  params,
  Pagination,
  Navbar,
  XLSX,
  saveAs,
} from "../../components/CustomComponent.js";
export default class CommissionAgent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      count: 10,
      filter_currency: "THB",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(0);
  }
  Get = async (page) => {
    const { filter_currency } = this.state;
    let data, count;
    loading(true);
    let [result] = await Promise.all([
      GET("profits/monthly-commission", {
        page_size: 10,
        page: page,
        currency: filter_currency,
      }),
    ]);
    if (result?.status) {
      data = result.data.filter((e) => e.agent.name_en === profile?.full_name);
      count = result.count;
    }
    this.setState({ data, count });
    loading(false);
  };
  ExportCSV = async () => {
    const { data, filter_currency } = this.state;
    // EXPORT EXCEL
    const json_data = data
      .filter((item) => item.currency === filter_currency)
      .map((item) => ({
        Year: item.year,
        Month: item.month,
        "Start Date": item.start_date
          ? format_date(item.start_date, "dd/mm/yyyy hh:mm:ss", "th")
          : "",
        "End Date": item.end_date
          ? format_date(item.end_date, "dd/mm/yyyy hh:mm:ss", "th")
          : "",
        Currency: item.currency,
        Amount: item.total_amount ? toFixed(item.total_amount, 2) : "00.00",
        Commission: toFixed(item.total_commission, 2),
        Paid: item.status_payment === "success" ? "Paid" : "Unpaid",
      }));
    // 1. Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(json_data);

    // 2. Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // 3. Write the workbook to binary buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // 4. Save to file
    const file = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(file, `commission-agent.xlsx`);
  };
  render() {
    const { filter_currency, data, count } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
<div>
              <div className="ar-eyebrow mb-1">Agent</div>
              <h2 className="ar-title mb-1">Commission Reports</h2>
              <div className="ar-subtitle">
                Agent commission tracking and payment is calculated from 15th at
                00:00:00 of the previous month to 14th at 23:59:59 of this month.
              </div>
            </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-ghost"
                  onClick={async () => {
                    this.ExportCSV();
                  }}
                >
                  Export CSV
                </button>
              </div>
            </div>
<div className="ar-toolbar ar-filter mt-3">
  <div className="ar-filter-head">
    <span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
  </div>
  <div className="ar-filter-foot">
                  {global.currency?.map((item) => (
                    <button
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code });
                        setTimeout(() => {
                          this.Get(0);
                        }, 100);
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
  </div>
</div>
            </div>

          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf1ad"}</span>
                  Agent Commission
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover text-nowrap ar-table pu-table">
                <thead>
                  <tr>
                    <td className="text-nowrap text-center">Year</td>
                    <td className="text-nowrap text-center">Month</td>
                    <td className="text-nowrap text-center">Start Date</td>
                    <td className="text-nowrap text-center">End Date</td>
                    <td className="text-nowrap text-center">Currency</td>
                    <td className="text-nowrap text-end">
                      Amount ({filter_currency})
                    </td>
                    <td className="text-nowrap text-end">
                      Commission ({filter_currency})
                    </td>
                    <td className="text-nowrap text-center">Paid</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={`array-${index}`}>
                      <td data-label={`Year`} className="text-center py-1">
                        {item.year}
                      </td>
                      <td data-label={`Month`} className="text-center py-1">
                        {item.month}
                      </td>
                      <td
                        data-label={`Start Date`}
                        className="text-center py-1"
                        onClick={() => this.GetByID(item.uid)}
                      >
                            {item.start_date
                              ? format_date(item.start_date, "dd/mm/yyyy hh:mm:ss", "th")
                              : ""}
                      </td>
                      <td
                        data-label={`End Date`}
                        className="text-center py-1"
                        onClick={() => this.GetByID(item.uid)}
                      >
                            {item.end_date
                              ? format_date(item.end_date, "dd/mm/yyyy hh:mm:ss", "th")
                              : ""}
                      </td>
                      <td
                        data-label={`Currency`}
                        className="text-nowrap text-center"
                      >
                        {item.currency}
                      </td>
                      <td
                        data-label={`Amount (${filter_currency})`}
                        className="text-nowrap text-end"
                      >
                        {item.total_amount
                          ? toFixed(item.total_amount, 2)
                          : "00.00"}
                      </td>
                      <td
                        data-label={`Commission (${filter_currency})`}
                        className="text-nowrap text-end text-primary"
                      >
                        {toFixed(item.total_commission, 2)}
                      </td>
                      <td data-label={`Paid`} className="text-center">
                        <div className="d-flex justify-content-center">
                          {item.status_payment === "success"
                            ? Status("paid", "success")
                            : Status("unpaid", "warning")}
                        </div>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td className="d-none d-md-table-cell text-center fw-bold">
                      Total
                    </td>
                    <td
                      data-label={`Amount (${filter_currency})`}
                      className="text-nowrap text-end fw-bold"
                    >
                      {toFixed(total(data, "total_amount"), 2)}
                    </td>
                    <td
                      data-label={`Commission (${filter_currency})`}
                      className="text-nowrap text-end text-primary fw-bold"
                    >
                      {toFixed(total(data, "total_commission"), 2)}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div> */}
        </div>
      </div>
    );
  }
}
